import React, { memo } from 'react'
import DataTable from 'react-data-table-component'
import Pagination from './Pagination'
import styles from './Table.module.scss'
import CircleSpinner from 'components/shared/loader/CircleSpinner'

const Table = (props) => {
    return (
        <>
            <DataTable
                {...props}
                pagination={false}
                columns={props?.columns}
                className={styles.table}
                progressComponent={<CircleSpinner />}
                fixedHeader={true}
                fixedHeaderScrollHeight='auto'
            />
            {props?.paginationProps?.isPagination && <Pagination {...props?.paginationProps} />}
        </>
    )
}

export default memo(Table)